import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/bajaCajas';
import Baja from './BajaCajasList';

const ms2p = (state) => {
  return {
    ...state.baja_cajas,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Baja);
